import { gql } from '@apollo/client';
import { COMPANY_FRAGMENT } from 'graphql/secure/fragments';
import {
  BASE_COMPANY_USER_FRAGMENT,
  COMPANY_USER_FRAGMENT,
} from '../fragments/compnayUser.fragments';

export const GET_USER_DETAILS = gql`
  query GetUserDetails {
    user {
      ...companyUserValues
    }
  }
  ${COMPANY_USER_FRAGMENT}
`;

export const GET_USER_LOGIN_DETAILS = gql`
  query GetUserLoginDetails {
    user {
      ...companyUserValues
    }
    company {
      ...companyValues
    }
  }
  ${COMPANY_USER_FRAGMENT}
  ${COMPANY_FRAGMENT}
`;

export const GET_USERS = gql`
  query GetUsers {
    companyUsers {
      edges {
        cursor
        node {
          ...baseCompanyUserValues
        }
      }
    }
  }
  ${BASE_COMPANY_USER_FRAGMENT}
`;

export const GET_INVITED_PARTNER_USER = gql`
  query GetInvitedPartnerUser($id: UUID!) {
    invitedPartnerCompanyUser(id: $id) {
      ...baseCompanyUserValues
    }
  }
  ${BASE_COMPANY_USER_FRAGMENT}
`;
